import { ReactNode } from 'react';

import { CountryEntity } from 'api/types/entity';
import { Dialog, DialogProps, Stack } from 'libs/ui';
import {
  WithdrawalAccountFormType,
  Form,
  withdrawalAccountSchema,
} from 'modules/client/common/forms/withdrawalAccountForm';

import { FormContent } from './FormContent';
import { Header } from './FormContent/Header';
import { DialogContentStyled } from './styles';

interface Props extends DialogProps {
  onClose: () => void;
  onSubmit: (value: WithdrawalAccountFormType) => void;
  footerActions?: ReactNode;
  initialValues: WithdrawalAccountFormType;
  countries: CountryEntity[];
  countriesLoading: boolean;
  readOnly?: boolean;
}

export const DialogWithdrawalAccountFeature = ({
  isOpen,
  onClose,
  onSubmit,
  footerActions,
  initialValues,
  countries,
  countriesLoading,
  readOnly,
}: Props) => (
  <Dialog
    disableBackdropClick
    fullWidth={false}
    isOpen={isOpen}
    maxWidth="xl"
    onClose={onClose}
  >
    <Form
      initialShowCopyButton
      initialReadOnly={readOnly}
      initialValues={initialValues}
      validationSchema={withdrawalAccountSchema}
      onSubmit={onSubmit}
    >
      <DialogContentStyled>
        <Stack spacing={32}>
          <Header />
          <FormContent
            countries={countries}
            countriesLoading={countriesLoading}
          />

          {footerActions}
        </Stack>
      </DialogContentStyled>
    </Form>
  </Dialog>
);
